import React from 'react'

export default function DismissIcon() {
  return (
    <svg viewBox='0 0 32 32' className='svgIcon iconDismiss'>
      <path d='M4 8 L8 4 L16 12 L24 4 L28 8 L20 16 L28 24 L24 28 L16 20 L8 28 L4 24 L12 16 z'></path>
    </svg>
  )
}
